import React from "react";
import { ErrorDiv } from '.' ;

const SmartErrorDiv = ({sectionName, name, formErrors, maxLength}) =>
{
    if (formErrors[sectionName]?.[name] === undefined)
    {
        return null;
    }
    else if (formErrors[sectionName][name]?.type === 'maxLength')
    {
        return <ErrorDiv>{'Please enter up to ' + maxLength + ' characters'}</ErrorDiv>
    }
    else if (formErrors[sectionName][name]?.type === 'required')
    {
        return <ErrorDiv>{'Please enter a value'}</ErrorDiv>
    }
    else if ( ['validate', 'pattern'].includes (formErrors[sectionName][name]?.type ))
    {
        return <ErrorDiv>{formErrors[sectionName][name].message}</ErrorDiv>
    }
    else if ( ['custom'].includes (formErrors[sectionName][name]?.type )) //The same as above for now but may be different for custom messages in the future
    {
        return <ErrorDiv>{formErrors[sectionName][name].message}</ErrorDiv>
    }
    else
    {
        return <ErrorDiv>Invalid Input</ErrorDiv>
    }
}

export { SmartErrorDiv };
